import APIAxios from '../APIAxios.ts';
import ICurrentIndex from '../view_modals/ICurrentIndex.ts';
import IFacilitatorLogin from '../view_modals/IFacilitatorLogin.ts';
import IMoveToNext from '../view_modals/ImoveToNext.ts';

// Define the functions
const login = async (vm: IFacilitatorLogin) => {
    try {
        const response = await APIAxios.post('/Facilitator/Login', vm);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const moveTonext = async (vm: IMoveToNext) => {
    try {
        const response = await APIAxios.post('/Scoring/MoveToIndex', vm);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const moveTonextcollectible = async (vm: ICurrentIndex) => {
    try {
        const response = await APIAxios.post('/Scoring/IncrementIndex', vm);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

// Assign the object to a variable
const scoringService = {
    login,
    moveTonext,
    moveTonextcollectible
};

// Export the variable
export default scoringService;
